<template>
    <button ref="button" 
            class="button-default" 
            :class="`button-${buttonColor} ${status}`"
            @click="eventButton"
            :style="defineStyle"
            :disabled="status == 'disabled' ? true : false">
        {{textButton}}
    </button>
</template>
<script>
import Bus from '../../main.js'
import {addAlpha} from '../../helpers/custom.js'
export default {
    props:{
        textButton : {
            type : String,
            required : true
        },
        buttonColor : {
            type : String
        },
        height : {
            type : String
        },
        actionName : {
            type : String
        },
        status : {
            type : String,
            default : 'able'
        }
    },
    created(){
        // console.log("Disabled? ", this.status)
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },    
    data(){
        return{
            colors: {},
            buttonStyle : ''
        }
    },
    methods: {
        eventButton(){
            this.effectButton()
            this.$emit('eventButtonDefault')
            this.actionName ? Bus.$emit(`${this.actionName}`) : ''
        },       
        effectButton(){
            let buttonDefault = this.$refs.button
            let self = this
            buttonDefault.classList.add(`button-${this.buttonColor}`)
            buttonDefault.classList.add(`button-effect-${this.buttonColor}`)
            setInterval(function(){ buttonDefault.classList.remove(`button-effect-${self.buttonColor}`) }, 200);
        }
    },
    computed:{
        defineStyle(){
            // if(this.theme == 'dark')
            let color = ''
            let backgroundColor = this.status == 'disabled' || this.status == 'expired' ? '#bfbfbf' : this.colors.secondary
            let boxShadowColor = this.status == 'disabled' || this.status == 'expired' ? '0px 5px 0px 0px' + addAlpha('#5e5e5e', 0.5) : '0px 5px 0px 0px' + addAlpha(this.colors.secondary, 0.5)
            return {
                'box-shadow': boxShadowColor,
                'background-color': backgroundColor,
                'color': color
            }
        }, 
    }
}
</script>
<style lang="scss" scoped>
    .button-default{
        width: 100%;
        // background-color: #fff576;
        height: 40px;
        border: none;
        // border-bottom: 5px solid #e9a661;
        font-weight: bold;
        font-size: 11px;
        outline: none;
        letter-spacing: 2px;
        box-shadow: 0px 5px 5px 0px rgba(105, 105, 105, 0.315);
        cursor: pointer;
        text-transform: uppercase;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;        
    }

    .disabled{
        background-color: #ffffff;
        // border-bottom: 5px solid #d4dcdc;
        color: #dcdcdc;
    }
    
    .button-effect-yellow{

        border-top: 5px solid #6af6ed;
        border-bottom: #fff576;
    }

    .button-white{
        background-color: #ffffff;
        border-bottom: 5px solid #e0e0e0;
    }

    .button-effect-white{
        border-top: 5px solid #6af6ed;
        border-bottom: #ffffff;
    }
</style>
